
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      images: {
        serverPlatform: require("@images/platform_logo.png"),
        diviLogo: {
          name: "迪唯",
          src: require("@images/divi_logo.png"),
          url: "http://www.dividiy.com/",
        },
      },
      linkList: [
        {
          title: "下载",
          url: "",
          items: [
            { name: "windows版本", url: "" },
            { name: "Mac版本(敬请期待)", url: "" },
          ],
        },
        {
          title: "产品",
          url: "",
          items: [
            { name: "常见问题（FAQ）", url: "" },
            { name: "使用说明", url: "" },
          ],
        },
      ],
      copyright: "",
    };
  },
})
export default class Header extends Vue {}
